import { createRoute } from '@tanstack/react-router';

import { rootRoute } from '../../router/routes/rootRoute';

export const fipRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/fip',
});
